import { PublicClientApplication } from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID_DEV,
    authority: 'https://login.microsoftonline.com/' + process.env.VUE_APP_AZURE_TENANT_ID_DEV,
    redirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI + 'callback-auth'
  },
  cache: {
    cacheLocation: 'sessionStorage'
  }
}

export const loginRequest = {
  scopes: ['User.Read']
}

export const msalInstance = new PublicClientApplication(msalConfig)
